import { useRef, useState } from "react";
import Input from "../../componentes/input/input";
import UsuarioVpnService from "../../services/resource/usuarioVpnService";
import Button from "../../componentes/button/button";
import DropDown from "../../componentes/dropdown/dropdown";
import LOGO from '../../assets/york.png'
import Textarea from "../../componentes/input/textarea";
import { OverlayPanel } from "primereact/overlaypanel";

export default function UsuarioVPNForm() {
    const service = new UsuarioVpnService();

    const [form, setForm] = useState({
        nomeCompleto: "",
        licenca: "",
        usuarioVpn: "",
        email: "",
        temAcessoNetskope: null,
        sistemasUtilizados: ""
    });

    const [loading, setLoading] = useState(false);
    const [salvo, setSalvo] = useState(false);
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});

    function handleChange(name, value) {
        setForm(prev => ({ ...prev, [name]: value }));
    }

    function validarCampo(name, value) {
        if (typeof value === "string") value = value.trim();

        switch (name) {
            case "nomeCompleto":
                if (!value) return "Informe o nome completo";
                if (value.length > 120) return "Máx. 120 caracteres";
                return null;

            case "licenca":
                if (!value) return "Informe a licença";
                if (value.length > 40) return "Máx. 40 caracteres";
                return null;

            case "usuarioVpn":
                if (!value) return "Informe o usuário VPN";
                if (value.length > 60) return "Máx. 60 caracteres";
                return null;

            case "email":
                if (!value) return "Informe o email";
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(value)) return "Email inválido";
                if (value.length > 120) return "Máx. 120 caracteres";
                return null;

            case "temAcessoNetskope":
                if (value === null || value === undefined) return "Selecione uma opção";
                return null;

            default:
                return null;
        }
    }

    function handleBlur(name, value) {
        setTouched(prev => ({ ...prev, [name]: true }));

        const erro = validarCampo(name, value);
        setErrors(prev => ({ ...prev, [name]: erro }));
    }


    async function handleSubmit(e) {
        e.preventDefault();

        const novosErros = {};
        const novosTouched = {};

        Object.entries(form).forEach(([name, value]) => {
            novosTouched[name] = true;
            const erro = validarCampo(name, value);
            if (erro) novosErros[name] = erro;
        });

        setTouched(novosTouched);
        setErrors(novosErros);

        if (Object.keys(novosErros).length > 0) return;

        service.enviarFormulario(form)
            .then(res => setSalvo(true))
            .catch(e => console.error)
            .finally(() => setLoading(false));
    }

    const op = useRef(null);
    return (
        <div className="min-h-screen bg-background flex items-center justify-center p-6">

            <div className="surface-card p-4 w-full max-w-[80%]">

                {/* Cabeçalho */}
                <div className="mb-6 text-center">
                    <div className="flex justify-center mb-3">
                        <img src={LOGO} alt="Logo York" width={200} />
                    </div>
                    <h1 className="font-display text-2xl font-semibold text-foreground">
                        Atualização de Acesso VPN
                    </h1>

                    <p className="text-muted-foreground mt-2 text-sm leading-relaxed">
                        A Solar está realizando a migração do sistema de acesso remoto,
                        substituindo o FortiClient pelo Netskope.
                        <br />
                        Precisamos confirmar seus dados para preparar sua liberação
                        no novo ambiente de acesso seguro.
                    </p>
                </div>

                {salvo ?
                    <div className="flex items-center justify-center p-6">
                        <div className="bg-muted rounded-xl p-8 max-w-lg w-full text-center">

                            <h2 className="font-display text-2xl font-semibold text-success mb-3">
                                Dados enviados com sucesso
                            </h2>

                            <p className="text-muted-foreground">
                                Suas informações já foram registradas para a migração do acesso VPN.
                                Caso seja necessário, a equipe de TI entrará em contato.
                            </p>

                        </div>
                    </div>
                    :
                    <form onSubmit={handleSubmit}>

                        <div className="grid grid-cols-1 md:grid-cols-6 gap-2 mb-3">

                            <Input
                                label="Nome completo"
                                value={form.nomeCompleto}
                                onChange={e => handleChange("nomeCompleto", e.target.value)}
                                onBlur={e => handleBlur("nomeCompleto", e.target.value)}
                                error={errors.nomeCompleto}
                                touched={touched.nomeCompleto}
                                maxLength={120}
                                required
                                colSpan={3}
                            />

                            <Input
                                label="Email corporativo"
                                type="email"
                                value={form.email}
                                onChange={e => handleChange("email", e.target.value)}
                                onBlur={e => handleBlur("email", e.target.value)}
                                error={errors.email}
                                touched={touched.email}
                                maxLength={120}
                                required
                                colSpan={3}
                            />

                            <Input
                                label="Nome de Usuário da VPN"
                                value={form.usuarioVpn}
                                onChange={e => handleChange("usuarioVpn", e.target.value)}
                                onBlur={e => handleBlur("usuarioVpn", e.target.value)}
                                error={errors.usuarioVpn}
                                touched={touched.usuarioVpn}
                                maxLength={60}
                                required
                                colSpan={2}
                            />

                            <Input
                                label="Número da Licença"
                                type="number"
                                value={form.licenca}
                                onChange={e => handleChange("licenca", e.target.value)}
                                onBlur={e => handleBlur("licenca", e.target.value)}
                                error={errors.licenca}
                                touched={touched.licenca}
                                maxLength={40}
                                colSpan={2}
                                required
                                labelChildren={
                                    <i className='ml-1 fa fa-question-circle cursor-pointer' onClick={(e) => op.current.toggle(e)} />
                                }
                            />

                            <OverlayPanel ref={op}>
                                <div className="flex flex-col p-2">
                                    <label onClick={() => handleChange("licenca", 6425)}>6425 <span className="text-muted-foreground"> (Teresina)</span> </label>
                                    <label onClick={() => handleChange("licenca", 6429)}>6429 <span className="text-muted-foreground"> (Picos)</span> </label>
                                    <label onClick={() => handleChange("licenca", 6433)}>6433 <span className="text-muted-foreground"> (Piripiri)</span> </label>
                                    <label onClick={() => handleChange("licenca", 6449)}>6449 <span className="text-muted-foreground">(Floriano) </span> </label>
                                    <label onClick={() => handleChange("licenca", 6648)}>6648 <span className="text-muted-foreground"> (Caxias)</span> </label>
                                </div>
                            </OverlayPanel>

                            <DropDown
                                label="Já recebeu convite do Netskope?"
                                value={form.temAcessoNetskope}
                                filter={false}
                                onChange={e => handleChange("temAcessoNetskope", e.target.value)}
                                onBlur={e => handleBlur("temAcessoNetskope", e.value)}
                                error={errors.temAcessoNetskope}
                                colSpan={2}
                                touched={touched.temAcessoNetskope}
                                options={[
                                    { label: 'Sim', value: true },
                                    { label: 'Não', value: false },
                                ]}
                            />

                            <Textarea
                                label="Sistemas utilizados com acesso da VPN: "
                                value={form.sistemasUtilizados}
                                onChange={e => handleChange("sistemasUtilizados", e.target.value)}
                                required
                                colSpan={6}
                            />
                        </div>

                        <Button
                            type="submit"
                            disabled={loading}
                            label="Enviar Informações"
                            iconLeft="fa fa-save"
                        />

                    </form>
                }
            </div>
        </div>
    );
}
